import { useState } from "react";
import ReactLinkify from "react-linkify";

const TextShortener = ({fullText, words}) => {
    const [isExpanded,setIsExpanded]=useState(false);
    const fullTextArray = fullText.split(' ');
    const shortText = `${fullText.split(' ').slice(0, words).join(' ')}`;

    const linkDecorator = (href, text, key) => (
        <a style={{color:"#0251EB",textDecoration:"none"}} href={href} key={key} target="_blank" rel="noopener noreferrer">
          {text}
        </a>
      );

    return ( 
        <pre>
            <ReactLinkify componentDecorator={linkDecorator}>
            {isExpanded ? fullText : shortText}
            {fullTextArray && fullTextArray.length > words && (
                      <button onClick={()=>setIsExpanded(prev => !prev)}
                      style={{backgroundColor:"transparent",
                              cursor:"pointer",
                              border:"none",
                              fontWeight:"bolder"
                      }}>
                          {isExpanded ? 'Read Less' : '...Read More'}
                      </button>
            )}
            </ReactLinkify>
        </pre>
     );
}
export default TextShortener;